import React from 'react'
import classnames from 'classnames'
import Select from 'react-select'

import styles from './styles.css'

const AddItemModal = ({
  inputValue,
  inputOnChange,
  inputPlaceholder,
  inputKeyPress,
  button1Name,
  button2Name,
  button1Function,
  button2Function,
  showSelect = false,
  selectValue,
  selectOnChange,
  selectOptions,
  selectCustomStyles,
  placeholder,
}) => (
  <div className={classnames(styles.form)}>
    <input
      className={classnames(styles.input)}
      type="text"
      placeholder={inputPlaceholder}
      value={inputValue}
      onChange={inputOnChange}
      onKeyPress={inputKeyPress}
      autoFocus="true"
    />
    {showSelect && (
      <Select
        className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.input)}
        value={selectValue}
        onChange={selectOnChange}
        options={selectOptions}
        styles={selectCustomStyles}
        placeholder={placeholder}
      />
    )}

    <div>
      <button className={classnames(styles.button)} onClick={button1Function}>
        {button1Name}
      </button>
      <button className={classnames(styles.button)} onClick={button2Function}>
        {button2Name}
      </button>
    </div>
  </div>
)

export default AddItemModal



// WEBPACK FOOTER //
// ./src/views/tomorrow-items/add-item-modal/index.js